<style type="text/css">
    @media print {
        div.page {
            page-break-after: always;
            page-break-inside: avoid;
        }
    }
</style>
<!-- w-full max-w-[730px] h-full max-h-[1050px] bg-primary-white-01 rounded-2xl px-10 py-2 flex flex-col overflow-auto custom-scroll -->
<div class="mx-auto w-full bg-white max-w-[816px]">
    <ng-container *ngFor="let currentPagare of arrPagares">
        <div class="flex flex-col max-h-[1056px] min-h-[1056px] px-20 pt-12 pb-2 page">
            <pagare [pagare]="currentPagare" [plantillaHtml]="plantillaHtml" *ngIf="plantillaHtml"></pagare>
        </div>
    </ng-container>
</div>
<!-- INVESTIGAR -->
<ng-container *ngIf="htmlToAdd">
    <div id='loaded'></div>
</ng-container>